class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '#mobile-menu',
			toolbar: '#toolbar',
			toggleMenuButton: '.toggle-menu',
			menuGroup: '.mobile-menu-item.has-children > .item-title',
			menuBack: '.menu-back > .back-button',
		}, config);

		this.$toolbar = $(this.config.toolbar);
		this.$scope = $(this.config.scope);

		this.init();
	}

	init() {
		this.setHeight();
		this.addEventListeners();
	}

	addEventListeners() {
		$(this.config.toggleMenuButton).on('click', this.toggleMenu.bind(this));
		this.$scope.on('click', this.config.menuGroup, this.openSubMenu.bind(this));
		this.$scope.on('click', this.config.menuBack, this.closeSubMenu.bind(this));
		$(window).resize(this.setHeight.bind(this));
	}

	toggleMenu(e) {
		e.preventDefault();
		$('.hamburger').toggleClass('is-active');
		let $button = $(e.currentTarget);
		let $menu = this.$scope;

		if($('body').data('open') != true) {
			$menu.addClass('open');
			$('html').addClass('no-scrolling');
			$button.find('.hamburger').addClass('is-active');
			$('body').data('open', true);
		} else {
			$menu.removeClass('open');
			$menu.find('.children').removeClass('open');
			$('html').removeClass('no-scrolling');
			$button.find('.hamburger').removeClass('is-active');
			$('body').data('open', false);
		}
	}

	openSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.mobile-menu-item').find('> .children').addClass('open');
	}

	closeSubMenu(e) {
		e.preventDefault();
		$(e.currentTarget).closest('.children').removeClass('open');
	}

	setHeight() {
		let height = $(window).height() - this.$toolbar.height();
		this.$scope.height(height);
	}
}

export default new Header();